import { Sparkles, Store } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CtaBanner } from "@/shared/ui/site";

/**
 * El bloque de cierre de la TIENDA — y es UNO SOLO.
 *
 * ── A dónde lleva, y por qué cambió ──────────────────────────────────
 * A `/franquicias`. Antes llevaba a `/register`, y eso convertía el
 * remate del catálogo en un formulario: quien acaba de recorrer los
 * productos no quiere una contraseña, quiere saber qué hay detrás. El
 * dictado (`docs/01_MODELO_FRANQUICIA_Y_ONBOARDING.md`) lo dice desde su
 * primera línea: la franquicia digital es la puerta del negocio, y la
 * tienda es donde más gente la encuentra.
 *
 * ── Por qué hay uno y no dos ─────────────────────────────────────────
 * Estuvo a punto de haber dos: este y un segundo hacia la franquicia,
 * debajo. Al mover ESTE a `/franquicias`, los dos apuntarían al mismo
 * sitio con distinta ropa — dos cierres seguidos que dicen lo mismo se
 * anulan, y quien lee acaba sin pulsar ninguno. Así que el mensaje del
 * segundo (la pregunta del mayoreo y del negocio propio) es ahora el
 * titular de este, y el segundo bloque desapareció.
 *
 * ── La etiqueta tiene que prometer el destino ────────────────────────
 * "Crear mi cuenta" prometía un formulario de registro. Lo que hay al
 * otro lado es la página de la franquicia, así que el botón lo dice:
 * "Adquiere una franquicia digital". Un botón que promete una cosa y
 * entrega otra se paga en la siguiente pantalla, con el abandono.
 *
 * La FORMA no se tocó: misma píldora blanca, mismo icono, mismo bloque
 * en tinta. Lo que cambia es a dónde va y qué dice.
 *
 * ── `highlight` es su propia clave ───────────────────────────────────
 * No es un trozo cortado del título: la palabra que se resalta tiene que
 * existir dentro de la frase YA TRADUCIDA, y en inglés cae en otra
 * posición. Traduciendo las dos claves, el resalte se mueve con la frase.
 */
export function ShopCta() {
  const { t } = useTranslation();

  return (
    <CtaBanner
      eyebrow={t("Negocio digital")}
      eyebrowIcon={<Sparkles />}
      title={t(
        "¿Buscas producto al por mayor o quieres iniciar tu propio negocio virtual con It's The Best?",
      )}
      highlight={t("negocio virtual")}
      subtitle={t(
        "La franquicia digital es la puerta: te da tu propia tienda en línea, el catálogo completo y el acompañamiento de la comunidad.",
      )}
      actionLabel={t("Adquiere una franquicia digital")}
      actionTo="/franquicias"
      actionIcon={<Store />}
      className="mb-20 mt-4 sm:mb-28"
    />
  );
}
